module.exports = __webpack_public_path__ + "img/FORTUNE.8cce4a23.svg";